import { defineMessages } from 'react-intl';

export default defineMessages({
  login: {
    id: 'cboard.components.Login.login',
    defaultMessage: 'Login'
  },
  email: {
    id: 'cboard.components.Login.email',
    defaultMessage: 'Email'
  },
  password: {
    id: 'cboard.components.Login.password',
    defaultMessage: 'Password'
  },
  cancel: {
    id: 'cboard.components.Login.cancel',
    defaultMessage: 'Cancel'
  },
  forgotPassword: {
    id: 'cboard.components.Login.forgotPassword',
    defaultMessage: 'Forgot password?'
  }
});
